import { render } from "./AdmBadge.vue?vue&type=template&id=d9b5783a&scoped=true"
import script from "./AdmBadge.vue?vue&type=script&lang=js"
export * from "./AdmBadge.vue?vue&type=script&lang=js"

import "./AdmBadge.vue?vue&type=style&index=0&id=d9b5783a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b5783a"]])

export default __exports__